/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.RoleActionResource = factory(root.GisServerApis.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The RoleActionResource model module.
   * @module model/RoleActionResource
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>RoleActionResource</code>.
   * A resource of the action that assigned to a role.
   * @alias module:model/RoleActionResource
   * @class
   * @param route {String} The route of the action.
   * @param verb {String} The verb of the action.
   * @param name {String} The name of the action.
   */
  var exports = function(route, verb, name) {
    var _this = this;

    _this['route'] = route;
    _this['verb'] = verb;
    _this['name'] = name;
  };

  /**
   * Constructs a <code>RoleActionResource</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RoleActionResource} obj Optional instance to populate.
   * @return {module:model/RoleActionResource} The populated <code>RoleActionResource</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('route')) {
        obj['route'] = ApiClient.convertToType(data['route'], 'String');
      }
      if (data.hasOwnProperty('verb')) {
        obj['verb'] = ApiClient.convertToType(data['verb'], 'String');
      }
      if (data.hasOwnProperty('name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
    }
    return obj;
  }

  /**
   * The route of the action.
   * @member {String} route
   */
  exports.prototype['route'] = undefined;
  /**
   * The verb of the action.
   * @member {String} verb
   */
  exports.prototype['verb'] = undefined;
  /**
   * The name of the action.
   * @member {String} name
   */
  exports.prototype['name'] = undefined;



  return exports;
}));



